import React, {
	useRef,
	useEffect,
	useState,
	useMemo,
	useCallback,
} from "react";
import DefaultSelect from "../../components/form/DefaultSelect";
import FinanceStatistic from "../../components/FinanceStatistic";
import { Button, Divider, Dropdown, Menu, Modal, Switch, message } from "antd";
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import DefaultInput from "../../components/form/DefaultInput";
import PaginationTable from "../../components/Pagination";
import { ColDef } from "ag-grid-enterprise";
import { ReactComponent as ExportIcon } from "../../assets/arrow-download-small.svg";
import { ReactComponent as SearchIcon } from "../../assets/search-find.svg";
import { ReactComponent as RegisterIcon } from "../../assets/add-plus.svg";
import { ReactComponent as ThreeDots } from "../../assets/three-dots.svg";
import FilterSection from "../../components/FilterOrderSection";
import api from "../../utils/axios";
import classes from "./index.module.css";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import DefaultPhoneInput from "../../components/form/DefaultPhoneInput";
import {
	fetchUserRoles,
	fetchZones,
	getConfigurationValue,
} from "../../lib/OptionListApi";
import { toast } from "react-toastify";
import { exportDataToCsv } from "../../utils/exportDataToCsv";
import DefaultPasswordInput from "../../components/form/DefaultPasswordInput";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { usernamePasswordValidate } from "../../types/UsernamePasswordValidate";
import { userRoles } from "../../types/enums";
import useLang from "../../hooks/useLang";
import {
	Checkbox,
	ListItemIcon,
	ListItemText,
	MenuItem,
	Select,
	useMediaQuery,
} from "@mui/material";

const StaffAcount = () => {
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
		}),
		[]
	);

	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [tableData, setTableData] = useState([]);
	const [fullName, setFullName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [address, setAddress] = useState("");
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [open, setOpen] = useState<boolean>(false);
	const [identificationNumber, setIdentificationNumber] = useState<
		string | undefined
	>();
	const [zones, setZones] = useState<any>([]);
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [sectionDropDown, setSectionDropDown] = useState<any>([]);
	const [country, setCountry] = useState<string | undefined>();
	const [city, setCity] = useState<string | undefined>();
	const [sectionId, setSectionId] = useState<string | undefined>();
	const [sections, setSections] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [userRolesDropDown, setUserRolesDropDown] = useState<any[]>();
	const [userRoleId, setUserRoleId] = useState<any>();
	const [unableZone, setUnableZone] = useState<boolean>(false);
	const [codeId, setCodeId] = useState<string | undefined>();
	const [editModal, setEditModal] = useState<boolean>(false);
	const [userData, setUserData] = useState<any>([]);
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [blockModalVisible, setBlockModalVisible] = useState(false);
	const [sectionModalVisible, setSectionModalVisible] = useState(false);
	const [personalIdLength, setPersonalIdLength] = useState<number>();
	const [error, setError] = useState<boolean>(false);
	const [collectorZones, setCollectorZones] = useState<any>([]);
	const [collectorId, setCollectorId] = useState<string | undefined | null>();
	let grid = useRef(null);

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const totalItems = tableData.length;

	const [collectorDropDown, setCollectorDropDown] = useState<any>([]);
	const [testDropDown, setTestDropDown] = useState<any>([]);
	const [selectedZones, setSelectedZones] = useState<any>([]);
	const [newZones, setNewZones] = useState<number[]>([]);
	const [deletedSections, setDeletedSections] = useState<number[]>([]);
	const [userIdToBlock, setUserIdToBlock] = useState<any>();
	const [userIdToDelete, setUserIdToDelete] = useState<any>();
	const { strings } = useLang("staffAccounts");

	const [modalRole, setModalRole] = useState<"collector" | "test" | null>(
		null
	);

	const openZoneModal = (role: "collector" | "test") => {
		setModalRole(role);
		setSectionModalVisible(true);
	};

	const getUserSections = async (value: any) => {
		try {
			const response = await api.get("Zone/user-sections", {
				params: { userId: value },
			});
			if (response.status === 200) {
				const collectorZones = response.data;
				setCollectorZones(collectorZones);
				const zoneIds = collectorZones.map(
					(zone: any) => zone.sectionId
				);
				setSelectedZones(zoneIds);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const collectorSelect = async (value: any) => {
		setCollectorId(value);
		await getUserSections(value);
	};

	const isAllSelected =
		sectionDropDown.length > 0 &&
		selectedZones.length === sectionDropDown.length;

	const handleZoneChange = (value: any) => {
		const initialZoneIds = collectorZones?.map(
			(zone: any) => zone.sectionId
		);
		let addedZones = [];
		let removedZones = [];

		if (value[value.length - 1] === "all") {
			const selected = sectionDropDown.map((zone: any) => zone.value);
			if (selectedZones.length === selected.length) {
				setSelectedZones([]);
				addedZones = [];
				removedZones = initialZoneIds?.filter((id: any) =>
					selected.includes(id)
				);
			} else {
				setSelectedZones(selected);
				addedZones = selected.filter(
					(id: any) => !initialZoneIds?.includes(id)
				);
				removedZones = [];
			}
		} else {
			setSelectedZones(value);
			addedZones = value.filter(
				(id: any) => !initialZoneIds?.includes(id)
			);
			removedZones = initialZoneIds?.filter(
				(id: any) => !value.includes(id)
			);
		}
		setNewZones(addedZones);
		setDeletedSections(removedZones);
	};

	const insertDeleteCollectorSections = async () => {
		if (!collectorId) {
			toast.error("Ju lutem zgjedhni nje staf");
			return;
		}
		const newZonesDto = newZones.map((zoneId: number) => ({
			sectionId: zoneId,
			userId: collectorId,
		}));
		const deletedSectionsDto = deletedSections.map((sectionId: number) => ({
			sectionId: sectionId,
			userId: collectorId,
		}));

		if (newZonesDto?.length < 0 || deletedSectionsDto?.length < 0) {
			toast.error("Nuk keni bere asnje ndryshim");
			return;
		}

		const data = {
			sections: newZonesDto,
			deletedSections: deletedSectionsDto,
		};
		const hasZonesChanged =
			newZonesDto.length > 0 || deletedSectionsDto.length > 0;
		try {
			const response = await api.post(
				"User/update-collector-sections",
				data
			);
			if (response.status === 200) {
				if (hasZonesChanged) {
					toast.success("Zonat u përditësuan me sukses!");
					clearCollectorModalStates();
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handlePageChange = (page: any) => {
		setCurrentPage(page);
	};

	const handlePageSizeChange = (current: number, size: number) => {
		setPageSize(size);
		setCurrentPage(1);
	};
	const getIdentificationNumberAllowedLength = async () => {
		try {
			setPersonalIdLength(parseInt(await getConfigurationValue(3)));
		} catch (error: any) {
			console.log(error);
		}
	};

	const filteredData = useMemo(() => {
		return tableData.filter((item: any) => {
			return (
				(!codeId ||
					(item.id &&
						JSON.stringify(item)
							?.toLowerCase()
							.includes(codeId.toString())) ||
					(item.firstName &&
						item.firstName
							?.toLowerCase()
							.includes(codeId?.toLowerCase())) ||
					(item.lastName &&
						item.lastName
							?.toLowerCase()
							.includes(codeId?.toLowerCase()))) &&
				(!city || item.cityId === city) &&
				(!country || item.countryId === country)
			);
		});
	}, [city, codeId, country, tableData]);

	const paginatedStaff = useMemo(() => {
		const dataToPaginate = filteredData;
		const startIndex = (currentPage - 1) * pageSize;
		const endIndex = startIndex + pageSize;
		return dataToPaginate.slice(startIndex, endIndex);
	}, [currentPage, filteredData, pageSize]);

	const startIndex = (currentPage - 1) * pageSize + 1;
	const endIndex = startIndex + Math.min(pageSize, totalItems - startIndex);

	const nameAndSurnameGetter = (params: any) => {
		const text = params.data.firstName + " " + params.data.lastName;
		return text;
	};

	const fetchTableData = async () => {
		try {
			const response = await api.get("User/staff");
			if (response.status === 200) {
				const result = response?.data.filter(
					(item: any) => item.userRoleId !== userRoles.DRIVER
				);
				const collectors = response?.data
					?.filter(
						(item: any) => item.userRoleId === userRoles.COLLECTOR
					)
					.map((item: any) => ({
						value: item.id,
						label: item.firstName + " " + item.lastName,
					}));
				const otherRoles = response?.data
					?.filter(
						(item: any) => item.userRoleId === userRoles.AGENCIES
					)
					.map((item: any) => ({
						value: item.id,
						label: item.firstName + " " + item.lastName,
					}));
				setCollectorDropDown(collectors);
				setTestDropDown(otherRoles);
				setTableData(result);
			}
		} catch (error) {
			console.log("Error: " + error);
		}
	};

	const handleEditUser = async (userId: number) => {
		try {
			const response = await api.get("User/userbyid", {
				params: { id: userId },
			});
			if (response.status === 200) {
				let responseData = response.data;
				setUserData(responseData);
				setUserRoleId(responseData.userRoleId);
				setEditModal(true);
			} else {
				toast.error("Failed to fetch user data");
			}
		} catch (error) {
			console.error("Error fetching user data:", error);
			toast.error("Failed to fetch user data");
		} finally {
		}
	};

	const getZones = useCallback(async () => {
		const allZones = await fetchZones();
		if (allZones) {
			const countries = allZones
				.filter((item: any) => item.levelId === 1)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryDropDown(countries);
			const filteredCities = allZones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = allZones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
			const filteredSections = allZones
				.filter((item: any) => item.levelId === 3)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setSectionDropDown(filteredSections);
			const sections = allZones.filter((item: any) => item.levelId === 3);
			setSections(sections);
		}
		setZones(allZones);
	}, [zones]);

	const getUserRoles = async () => {
		try {
			const results = await fetchUserRoles();
			if (results) {
				const roles = results
					.filter(
						(item: any) =>
							item.id !== userRoles.ADMIN &&
							item.id !== userRoles.CLIENT &&
							item.id !== userRoles.DRIVER &&
							item.id !== userRoles.CHATBOT &&
							item.id !== userRoles.SUBCLIENT
					)
					.map((item: any) => ({
						value: item.id,
						label: item.description,
					}));
				setUserRolesDropDown(roles);
			}
		} catch (error) {
			console.log("Error fetching User Roles:" + error);
		}
	};

	const optionsMenu = (userId: number) => [
		{
			label: (
				<Menu.Item onClick={() => handleEditUser(userId)}>
					{strings?.edit}
				</Menu.Item>
			),
			key: "item-1",
		},
		{
			label: (
				<Menu.Item onClick={() => blockUserAccount(userId)}>
					{strings?.block}
				</Menu.Item>
			),
			key: "item-2",
		},
		{
			label: (
				<Menu.Item
					onClick={() => {
						deleteUserAccount(userId);
					}}
				>
					{strings?.delete}
				</Menu.Item>
			),
			key: "item-3",
		},
	];

	const isSmallScreen = useMediaQuery("(max-width: 994px)");

	useEffect(() => {
		getUserRoles();
		getIdentificationNumberAllowedLength();
		setTableColumns([
			{
				headerCheckboxSelection: true,
				checkboxSelection: true,
				width: 50,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "id",
				headerName: strings?.code,
				cellStyle: (params: any) => ({
					fontSize: "15px",
					color: "blue",
				}),
				width: 80,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "firstName",
				valueGetter: nameAndSurnameGetter,
				headerName: strings?.namesurname,
				width: 150,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "phone",
				headerName: strings?.phone,
				width: 130,
				cellStyle: () => ({
					fontSize: "15px",
					color: "blue",
				}),
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "userRole",
				headerName: strings?.role,
				width: 170,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "email",
				headerName: strings?.email,
				width: 150,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "country",
				headerName: strings?.countryLabel,
				width: 90,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "city",
				headerName: strings?.cityLabel,
				width: 90,
				suppressSizeToFit: isSmallScreen,
			},
			{
				headerName: "",
				field: "options",
				width: 100,
				cellRendererFramework: (params: any) => {
					const userId = params.data.id;
					const menuItems = optionsMenu(userId);
					return (
						<Dropdown
							menu={{ items: menuItems }}
							trigger={["click"]}
						>
							<ThreeDots onClick={(e) => e.preventDefault()} />
						</Dropdown>
					);
				},
				suppressSizeToFit: isSmallScreen,
			},
		]);
		fetchTableData();
		getZones();
	}, [setTableColumns, strings]);

	const onUserRoleChange = (value: number) => {
		value === 4 || value === 14
			? setUnableZone(true)
			: setUnableZone(false);
		setUserRoleId(value);
	};

	const onCountrySelect = (e: any) => {
		setCity("");
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setCountry(e);
		setCurrentPage(1);
	};
	const onCitySelect = (e: any) => {
		setSectionId("");
		const filteredSections = sections
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setSectionDropDown(filteredSections);
		setCity(e);
		setCurrentPage(1);
	};

	const validateInsertedData = (data: any) => {
		const {
			firstName,
			lastName,
			phone,
			address,
			username,
			password,
			sectionId,
			userRoleId,
			identificationNumber,
		} = data;
		if (!firstName) {
			toast.error("Emri është i detyrueshëm");
			return false;
		}
		if (!lastName) {
			toast.error("Mbiemri është i detyrueshëm");
			return false;
		}
		if (!phone) {
			toast.error("Numri i telefonit është i detyrueshëm");
			return false;
		}
		if (!address) {
			toast.error("Adresa është e detyrueshme");
			return false;
		}
		if (!username) {
			toast.error("Username është i detyrueshëm");
			return false;
		}
		if (!password) {
			toast.error("Password është i detyrueshëm");
			return false;
		}
		if (!sectionId) {
			toast.error("Zona është e detyrueshme");
			return false;
		}
		if (!userRoleId) {
			toast.error("Roli  është i detyrueshëm");
			return false;
		}
		if (!identificationNumber) {
			toast.error("Nr.Leternjoftimit është i detyrueshëm.");
			return false;
		}
		if (identificationNumber.length !== personalIdLength) {
			toast.error(
				"Numri i leternjoftimit duhet të jetë i gjatë 10 karaktere."
			);
			return false;
		}
		return true;
	};

	const validateUpdatedData = (data: any) => {
		if (!data?.firstName) {
			toast.error("Emri është i detyrueshëm");
			return false;
		}
		if (!data?.lastName) {
			toast.error("Mbiemri është i detyrueshëm");
			return false;
		}
		if (!data?.phone) {
			toast.error("Numri i telefonit është i detyrueshëm");
			return false;
		}
		if (!data?.address) {
			toast.error("Adresa është e detyrueshme");
			return false;
		}
		if (!data?.username) {
			toast.error("Username është i detyrueshëm");
			return false;
		}
		// if (!data?.sectionId) {
		// 	toast.error("Zona është e detyrueshme");
		// 	return false;
		// }
		if (!data?.userRoleId) {
			toast.error("Roli  është i detyrueshëm");
			return false;
		}
		if (!data?.identificationNumber) {
			toast.error("Nr.Leternjoftimit është i detyrueshëm.");
			return false;
		}
		if (data?.identificationNumber?.length !== personalIdLength) {
			toast.error(
				"Numri i leternjoftimit duhet të jetë i gjatë 10 karaktere."
			);
			return false;
		} else {
			return true;
		}
	};

	const cleanStateOnClose = () => {
		setFullName("");
		setPhone("");
		setAddress("");
		setUsername("");
		setPassword("");
		setConfirmPassword("");
		setSectionId("");
		setUserRoleId("");
		setIdentificationNumber("");
		setEmail("");
		setUnableZone(false);
		setZones([]);
		setCountry("");
		setCity("");
		setOpen(false);
	};

	const insertNewUser = async () => {
		const fullNameArray = fullName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		const validation = usernamePasswordValidate(username, password);

		if (!validation.valid) {
			toast.error(validation.message);
			return;
		}

		const data = {
			firstName: firstName,
			lastName: lastName,
			// email: email,
			email: email ? email : null,
			username: username,
			password: password,
			phone: phone,
			address: address,
			userRoleId: userRoleId,
			sectionId: unableZone ? sectionId : 31,
			identificationNumber: identificationNumber,
		};
		if (validateInsertedData(data)) {
			try {
				const response = await api.post("User/insert-user", data);

				if (response.status === 200) {
					await fetchTableData();
					setOpen(false);
					toast.success("Llogaria u krijua me sukses!");
					cleanStateOnClose();
					return;
				} else {
					toast.error(
						"Një gabim ndodhi gjatë krijimit. Ju lutemi provoni përsëri më vonë"
					);
				}
			} catch (error: any) {
				console.error("Error creating account:", error.response.data);
			}
		} else {
			return;
		}
	};

	const blockUserAccount = (userId: any) => {
		setBlockModalVisible(true);
		setUserIdToBlock(userId);
	};

	const handleBlockUser = async () => {
		try {
			const response = await api.post("User/block-account", null, {
				params: { userId: userIdToBlock },
			});
			if (response.status === 200) {
				toast.success("Llogaria u bllokua me sukses");
				fetchTableData();
			} else {
				toast.error(
					"Bllokimi i llogarise deshtoj.Ju lutem provoni perseri me vone!"
				);
			}
		} catch (error) {
			console.error("Error blocking user account:", error);
		} finally {
			setBlockModalVisible(false);
		}
	};

	const deleteUserAccount = (userId: any) => {
		setDeleteModalVisible(true);
		setUserIdToDelete(userId);
	};

	const handleDeleteUser = async () => {
		try {
			const response = await api.delete("User/delete", {
				params: { id: userIdToDelete },
			});
			if (response.status === 200) {
				toast.success("Llogaria u fshi me sukses!");
				setDeleteModalVisible(false);
				fetchTableData();
			} else {
				toast.error(
					"Fshirja e llogarise deshtoj. Ju lutem provoni perseri me vone!"
				);
			}
		} catch (error) {
			console.error("Error blocking user account:", error);
		}
	};

	const updateUserData = async () => {
		const fullNameArray = userData?.nameAndSurname.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		const data = {
			id: userData.id,
			firstName: firstName,
			lastName: lastName,
			email: userData.email ? userData.email : null,
			address: userData.address,
			phone: userData.phone,
			username: userData.username,
			identificationNumber: userData.identificationNumber,
			userRoleId: userRoleId,
			// sectionId: unableZone ? sectionId : 31,
			password: password,
		};
		if (validateUpdatedData(data)) {
			try {
				const response = await api.post("User/update-staff-user", data);
				if (response.status === 200) {
					toast.success("Te dhenat u ndryshuan me sukses!");
					setEditModal(false);
					fetchTableData();
					cleanStateOnClose();
				} else {
					toast.error(
						"Nje gabim ndodhi. Ju lutemi provoni përsëri më vonë!"
					);
				}
			} catch (error: any) {
				console.error("Error updating user:", error);
				toast.error(
					"Nje gabim ndodhi. Ju lutemi provoni përsëri më vonë!"
				);
			}
		} else {
			return;
		}
	};

	const selectedColumnIds = [
		"id",
		"firstName",
		"phone",
		"userRole",
		"email",
		"country",
		"city",
	];

	const onExportSelectedId = () => {
		const dataToExport = filteredData.map((item: any) => ({
			...item,
			firstName: `${item.firstName} ${item.lastName}`,
		}));
		exportDataToCsv(grid, selectedColumnIds, dataToExport);
	};

	const handleConfirmPasswordChange = (e: any) => {
		setConfirmPassword(e.target.value);
		if (password === e.target.value) {
			setError(false);
		}
	};

	const handleBlur = useCallback(() => {
		if (password !== confirmPassword) {
			message.error("Fjalëkalimet nuk përputhen.");
			setError(true);
		} else {
			setError(false);
		}
	}, [confirmPassword, password]);

	const clearCollectorModalStates = () => {
		setSelectedZones([]);
		setCollectorId(null);
		setSectionModalVisible(false);
	};

	const clearCollectorSelect = () => {
		setCollectorId(null);
		setSelectedZones([]);
		setNewZones([]);
		setDeletedSections([]);
	};
	const onFirstDataRendered = useCallback((params: any) => {
		(grid.current as any).api.sizeColumnsToFit();
	}, []);

	return (
		<>
			<div className={classes.mainContainer}>
				{/* <FinanceStatistic /> */}

				<div className={classes.heroContainer}>
					<div className={classes.firstContainer}>
						<h1 className={classes.title}>
							{strings?.staffAccountsTitle} &nbsp;
							<span className={classes.clientsCount}>
								({tableData?.length})
							</span>
						</h1>
						<div className={classes.buttons}>
							<Button
								className={classes.button}
								onClick={onExportSelectedId}
							>
								<ExportIcon />
								{strings?.exportDataButton}
							</Button>
							<Button
								className={classes.button}
								onClick={() => setOpen(true)}
							>
								<RegisterIcon />
								{strings?.registerStaffButton}
							</Button>
							<Button
								className={classes.button}
								onClick={() => openZoneModal("collector")}
							>
								<RegisterIcon />
								{strings?.zones}
							</Button>
							<Button
								className={classes.button}
								onClick={() => openZoneModal("test")}
							>
								<RegisterIcon />
								Zonat per staff
							</Button>
						</div>
					</div>
					<div className={classes.inputs}>
						<DefaultInput
							label={strings?.searchLabel}
							className={classes.input}
							placeholder={strings?.searchPlaceholder}
							prefix={<SearchIcon />}
							value={codeId}
							onChange={(e) => {
								setCurrentPage(1);
								setCodeId(e.target.value);
							}}
						/>
						<DefaultSelect
							label={strings?.countryLabel}
							flexDirection="col"
							alignCenter="start"
							className={classes.input}
							placeholder={strings?.countryPlaceholder}
							options={countryDropDown}
							value={country}
							onChange={onCountrySelect}
							allowClear
						/>
						<DefaultSelect
							label={strings?.cityLabel}
							flexDirection="col"
							alignCenter="start"
							className={classes.input}
							placeholder={strings?.cityPlaceholder}
							options={cityDropDown}
							value={city}
							onChange={onCitySelect}
							allowClear
						/>
					</div>
					<div className={classes.pagination}>
						<PaginationTable
							current={currentPage}
							pageSize={pageSize}
							total={totalItems}
							startOrderIndex={startIndex}
							endOrderIndex={endIndex}
							onChange={handlePageChange}
							onShowSizeChange={handlePageSizeChange}
						/>
					</div>
					<div
						className="ag-theme-alpine"
						style={{
							height: 600,
							width: "100%",
						}}
					>
						<AgGridReact
							// rowData={filteredData}
							rowData={paginatedStaff}
							columnDefs={tableColumns}
							defaultColDef={defaultColDef}
							undoRedoCellEditing={true}
							undoRedoCellEditingLimit={20}
							suppressCopyRowsToClipboard={true}
							defaultExcelExportParams={
								defaultExcelExportSettings
							}
							rowSelection="single"
							ref={grid}
							enableRangeSelection={true}
							cacheQuickFilter={true}
							onFirstDataRendered={onFirstDataRendered}
						/>
					</div>
				</div>
			</div>
			<Modal
				open={open}
				title={strings?.registerModalTitle}
				onCancel={cleanStateOnClose}
				width={1000}
				footer={() => (
					<div className="flex items-end justify-end">
						<Button
							type="primary"
							size="large"
							// className="bg-blue-600"
							style={{ backgroundColor: "#4F16C2" }}
							onClick={insertNewUser}
						>
							{strings?.createAccountButton}
						</Button>
					</div>
				)}
			>
				<Divider />
				<div className={classes.mainModalEditContainer}>
					<DefaultInput
						className={classes.input}
						label={strings?.fullNameLabel}
						placeholder={strings?.fullNamePlaceholder}
						value={fullName}
						onChange={(e) => setFullName(e.target.value)}
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.emailLabel}
						placeholder={strings?.emailPlaceholder}
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<DefaultPhoneInput
						className={classes.phoneInput}
						label={strings?.phoneLabel}
						placeholder={strings?.phonePlaceholder}
						initialPhoneNumber={phone}
						onPhoneNumberChange={(v) => setPhone(v)}
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.idNumberLabel}
						value={identificationNumber}
						onChange={(e) =>
							setIdentificationNumber(e.target.value)
						}
						placeholder={strings?.idNumberPlaceholder}
					/>
					<DefaultSelect
						className={classes.input}
						label={strings?.countryLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.countryPlaceholder}
						options={countryDropDown}
						value={country}
						onChange={onCountrySelect}
					/>
					<DefaultSelect
						className={classes.input}
						label={strings?.cityLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.cityPlaceholder}
						options={cityDropDown}
						value={city}
						onChange={onCitySelect}
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.addressLabel}
						placeholder={strings?.addressPlaceholder}
						value={address}
						onChange={(e) => setAddress(e.target.value)}
					/>
					<DefaultSelect
						className={classes.input}
						label={strings?.roleLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.rolePlaceholder}
						options={userRolesDropDown}
						allowClear
						onClear={() => setUserRoleId(null)}
						value={userRoleId}
						onChange={onUserRoleChange}
					/>
					{unableZone && (
						<DefaultSelect
							className={classes.input}
							label={strings?.zoneLabel}
							flexDirection="col"
							alignCenter="start"
							placeholder={strings?.zonePlaceholder}
							options={sectionDropDown}
							value={sectionId}
							onChange={setSectionId}
						/>
					)}
				</div>
				<Divider />
				<div className={classes.mainModalEditContainer}>
					<DefaultInput
						className={classes.input}
						label={strings?.usernameLabel}
						value={username}
						onChange={(e) => setUsername(e.target.value)}
					/>
					<DefaultPasswordInput
						className={classes.input}
						label={strings?.passwordLabel}
						value={password}
						placeholder={strings?.passwordPlaceholder}
						onChange={(e) => setPassword(e.target.value)}
						onBlur={handleBlur}
						allowClear
					/>
					<DefaultInput
						label={strings?.confirmPasswordLabel}
						className={classes.input}
						value={confirmPassword}
						onChange={handleConfirmPasswordChange}
						onBlur={handleBlur}
						placeholder={strings?.passwordPlaceholder}
						status={error ? "error" : ""}
						type="password"
						suffix={
							error ? (
								<CloseCircleTwoTone twoToneColor="#ff4d4f" />
							) : (
								<CheckCircleTwoTone twoToneColor="#52c41a" />
							)
						}
						allowClear
					/>
				</div>
				<Divider />
			</Modal>
			<Modal
				open={editModal}
				title={strings?.editModalTitle}
				onCancel={() => setEditModal(false)}
				onOk={updateUserData}
				width={1000}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
			>
				<Divider />
				<div className={classes.mainModalEditContainer}>
					<DefaultInput
						className={classes.input}
						label={strings?.fullNameLabel}
						placeholder={strings?.fullNamePlaceholder}
						value={userData.nameAndSurname}
						onChange={(e) =>
							setUserData({
								...userData,
								nameAndSurname: e.target.value,
							})
						}
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.emailLabel}
						placeholder={strings?.emailPlaceholder}
						value={userData.email}
						onChange={(e) =>
							setUserData({ ...userData, email: e.target.value })
						}
					/>
					<DefaultPhoneInput
						className={classes.phoneInput}
						label={strings?.phoneLabel}
						placeholder={strings?.phonePlaceholder}
						initialPhoneNumber={userData.phone}
						onPhoneNumberChange={(e) =>
							setUserData({ ...userData, phone: e })
						}
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.idNumberLabel}
						value={userData.identificationNumber}
						onChange={(e) =>
							setUserData({
								...userData,
								identificationNumber: e.target.value,
							})
						}
						placeholder={strings?.idNumberPlaceholder}
					/>
					<DefaultSelect
						className={classes.input}
						label={strings?.countryLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.countryPlaceholder}
						options={countryDropDown}
						value={userData.country}
					/>
					<DefaultSelect
						className={classes.input}
						label={strings?.cityLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.cityPlaceholder}
						options={cityDropDown}
						value={userData.city}
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.addressLabel}
						placeholder={strings?.addressPlaceholder}
						value={userData.address}
						onChange={(e) =>
							setUserData({
								...userData,
								address: e.target.value,
							})
						}
					/>
					<DefaultSelect
						className={classes.input}
						label={strings?.roleLabel}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.rolePlaceholder}
						options={userRolesDropDown}
						allowClear
						onClear={() => setUserRoleId(null)}
						value={userRoleId}
						onChange={(value) => {
							setUserData({ ...userData, userRoleId: value });
							setUserRoleId(value);
						}}
					/>
					{unableZone && (
						<DefaultSelect
							className={classes.input}
							label={strings?.zoneLabel}
							flexDirection="col"
							alignCenter="start"
							placeholder={strings?.zonePlaceholder}
							options={sectionDropDown}
							value={sectionId}
							onChange={setSectionId}
						/>
					)}
				</div>
				<Divider />
				<div className={classes.mainModalEditContainer}>
					<DefaultInput
						className={classes.input}
						label={strings?.usernameLabel}
						value={userData.username}
						onChange={(e) =>
							setUserData({
								...userData,
								username: e.target.value,
							})
						}
					/>
					<DefaultPasswordInput
						className={classes.input}
						label={strings?.passwordLabel}
						value={password}
						placeholder={strings?.passwordPlaceholder}
						onChange={(e) => setPassword(e.target.value)}
						onBlur={handleBlur}
						allowClear
					/>
					<DefaultInput
						className={classes.input}
						label={strings?.confirmPasswordLabel}
						value={confirmPassword}
						onChange={handleConfirmPasswordChange}
						onBlur={handleBlur}
						placeholder={strings?.passwordPlaceholder}
						status={error ? "error" : ""}
						type="password"
						suffix={
							error ? (
								<CloseCircleTwoTone twoToneColor="#ff4d4f" />
							) : (
								<CheckCircleTwoTone twoToneColor="#52c41a" />
							)
						}
						allowClear
					/>
				</div>
				<Divider />
			</Modal>
			<Modal
				title={strings?.confirmDeleteTitle}
				open={deleteModalVisible}
				onOk={handleDeleteUser}
				onCancel={() => setDeleteModalVisible(false)}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
				okText={strings?.confirmDeleteOkButton}
				cancelText={strings?.confirmDeleteCancelButton}
			>
				<p>{strings?.confirmDeleteText}</p>
			</Modal>
			<Modal
				title={strings?.confirmBlockTitle}
				open={blockModalVisible}
				onOk={handleBlockUser}
				onCancel={() => setBlockModalVisible(false)}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
				okText={strings?.confirmBlockOkButton}
				cancelText={strings?.confirmBlockCancelButton}
			>
				<p>{strings?.confirmBlockText}</p>
			</Modal>

			<Modal
				title={
					modalRole === "collector"
						? "Shto ose Ndrysho zonat per mbledhësin"
						: "Shto ose Ndrysho zonat për Test-staff"
				}
				open={sectionModalVisible}
				onOk={insertDeleteCollectorSections}
				onCancel={clearCollectorModalStates}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
				width={700}
			>
				<Divider />
				<div className="flex flex-row justify-between items-center">
					<DefaultSelect
						className={classes.input}
						label={
							modalRole === "collector"
								? "Zgjidh Mbledhësin"
								: "Zgjidh Test-stafin"
						}
						flexDirection="col"
						alignCenter="start"
						placeholder={strings?.zonePlaceholder}
						options={
							modalRole === "collector"
								? collectorDropDown
								: testDropDown
						}
						value={collectorId}
						onChange={collectorSelect}
						allowClear
						onClear={clearCollectorSelect}
					/>
					<div className="flex flex-col items- center gap-1">
						<label className="-mb-1">Zgjedh Zonat</label>
						<Select
							multiple
							value={selectedZones}
							renderValue={(selected) => {
								const selectedLabels: any = selected
									.map((selectedZone: any) => {
										const matchingSections =
											sectionDropDown?.filter(
												(section: any) =>
													selectedZone ===
													section.value
											);
										return matchingSections?.map(
											(matchingSection: any) =>
												matchingSection?.label
										);
									})
									.flat()
									.filter((label: any) => label !== "");

								return selectedLabels.join(", ");
							}}
							className={classes.input}
							onChange={(selectedZoneIds: any) => {
								handleZoneChange(selectedZoneIds?.target.value);
							}}
							MenuProps={{
								PaperProps: {
									style: {
										maxHeight: 230,
										width: "20%",
									},
								},
							}}
						>
							<MenuItem value="all">
								<ListItemIcon>
									<Checkbox
										checked={isAllSelected}
										indeterminate={
											sectionDropDown.length > 0 &&
											selectedZones.length <
												sectionDropDown.length
										}
									/>
								</ListItemIcon>
								<ListItemText primary="Select All" />
							</MenuItem>
							{sectionDropDown?.map((zone: any) => (
								<MenuItem key={zone.value} value={zone.value}>
									<Checkbox
										checked={selectedZones?.includes(
											zone.value
										)}
									/>
									<ListItemText primary={zone?.label} />
								</MenuItem>
							))}
						</Select>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default StaffAcount;
